import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useAuth } from "../../context/AuthContext";
import { Avatar } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useData } from "../../context/DataContext";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  simple: {
    "&:hover": {
      backgroundColor: `transparent`,
    },
  },
}));

const Header = () => {
  const classes = useStyles();
  const { isAuth, activeUser } = useAuth();
  const data = useData();
  return (
    <div>
      <div className={classes.root}>
        <AppBar
          position="sticky"
          style={{ zIndex: 10000, top: 0 }}
          color="default"
        >
          <Toolbar>
            <Typography variant="h4" className={classes.title}>
              Bitstarter
            </Typography>
            {isAuth ? (
              <>
                <Typography variant="body2" className={classes.title}>
                  User Level:{" "}
                  {data[`level_${activeUser.currentLevel + 1 || 1}`].name}
                </Typography>
                <Button
                  className={`${classes.simple} m-2`}
                  variant="outlined"
                  component={Link}
                  to="/stats"
                  startIcon={
                    <Avatar
                      className={classes.small}
                      alt={`@${activeUser.username}`}
                      src={activeUser?.dp}
                    >
                      {activeUser.username?.[0]}
                    </Avatar>
                  }
                >
                  <b>{activeUser.username}</b>
                </Button>
              </>
            ) : (
              <Button component={Link} to="/login" color="inherit">
                Login
              </Button>
            )}
          </Toolbar>
        </AppBar>
      </div>
    </div>
  );
};

export default Header;
